import { render, staticRenderFns } from "./MultStat.vue?vue&type=template&id=03f9fb9a"
import script from "./MultStat.vue?vue&type=script&lang=js"
export * from "./MultStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports